export interface ProvinceSaticValue {
  cityPathArr: {
    cityName: string;
    regionCode: string;
    regionLevel: number;
  }[];
  //最近一年监管变化数据
  latestYearSupervise: {
    cautionNum: number;
    medicalCountNum: number;
    month: string;
  }[];
  // 当前地图  + 饼图统计数据
  subAreaCountData: {
    areaName: string;
    cautionTotal: number;
    doctorTotal: number;
    handleTotal: number;
    medicalTotal: number;
    organizationTotal: number;
    cityCode: string;
  }[];
  // 中心数据
  userAreaCountData: {
    areaName: string;
    cautionTotal: number;
    doctorTotal: number;
    handleTotal: number;
    medicalTotal: number;
    organizationTotal: number;
  };
}

// 近一年数据总览
export interface ProvinceOverviewValue {
  cautionTotal: number;
  total: number;
  handleTotal: number;
  medicalTotal: number;
  organizationTotal: number;
  urbanName: string;
}

// 诊疗行为异常分布
export interface ErrorDistributionValue {
  num: number;
  ruleName: string;
}

//监管数据占比
export interface StaticValue {
  regionCode: string;
  regionName: string;
  total: number;
}

// 监管机构类型占比数据
export interface RegulatoryData {
  name: string;
  num: number;
}

// 预警占比
export interface WarningRuleValue {
  cautionTotal: number;
  disposeTotal: number;
  regionCode: string;
  regionName: string;
  secondsTotal: number;
}
// 平均时间占比
export interface CountyRuleValue {
  cautionTotal: number;
  disposeTotal: number;
  ruleId: number;
  ruleName: string;
  secondsTotal: number;
}
// 县预警执法占比
export interface CountyRuleUserValue {
  provRuleId: number;
  provRuleName: string;
  total: number;
}

// 接入结构占比
export interface OrganizationValue {
  accessTotal: number;
  regionCode: string;
  regionName: string;
  total: number;
}

export const getStaticTitleName = (name: string) => {
  switch (name) {
    case "ORGANIZATION":
      return "监管机构占比";
    case "DOCTOR":
      return "监管医生占比";
    case "MEDICAL":
      return "区域诊疗行为占比";
    case "ORGANIZATIONTYPE":
      return "监管机构类型占比";
  }
};

export const getStaticName = (name: string) => {
  switch (name) {
    case "ORGANIZATION":
      return "监管机构";
    case "DOCTOR":
      return "监管医生";
    case "MEDICAL":
      return "诊疗行为";
    case "ORGANIZATIONTYPE":
      return "机构类型";
  }
};

export const getFlagName = (name: string) => {
  switch (name) {
    case "监管机构":
      return "ORGANIZATION";
    case "监管医生":
      return "DOCTOR";
    case "诊疗行为":
      return "MEDICAL";
    case "机构类型":
      return "ORGANIZATIONTYPE";
  }
};
// 1.区域监管机构占比  2.区域监管医生占比   3.区域诊疗行为占比

export const getWarningRuleTitleName = (name: string) => {
  switch (name) {
    case "预警占比":
      return "规则预警占比分析";
    case "处理时间":
      return "平均处理时间";
  }
};
// 1.规则预警占比分析  2.平均处理时间
